import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import * as Sentry from "@sentry/vue";
import {Storage} from "@/services/Storage"
import authModule from './modules/auth-module';
import userModule from './modules/user-module';
import websocket_modules from "@/store/modules/websocket_modules";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        userModule,
        authModule,
        websocket_modules
    },
    state: {
        registrationDetails: {},
        registeredStores: [],
        defaultStore: {},
        device_settings: {},
        loading: false,
        isUpdateAvailable: false,
        notification: undefined
    },
    getters: {
        getLoadingState: (state) => state.loading,
        getRegisteredStores: (state) => state.registeredStores,
        getRegistrationDetails: (state) => state.registrationDetails,
        getDefaultStore: (state) => state.defaultStore,
        getDeviceSettings: (state) => state.device_settings,
        getNofiication: (state) => state.notification,
        getUpdateAvailability: (state) => state.isUpdateAvailable,
    },
    mutations: {
        setUpdateAvailability: (state, payload) => state.isUpdateAvailable = payload,
        setNotification: (state) => state.notification = new Audio('bell-notification.mp3'),
        setLoadingState: (state, payload) => state.loading = payload,
        setRegisteredStores: async (state, data) => {
            if (!data) data = await Storage.getAllStores();
            else await Storage.setAllStores(data);
            state.registeredStores = data
        },
        setDeviceSettings: async (state, payload) => {
            if (payload) {
                await Storage.setDeviceSettings(payload);
            } else {
                payload = Storage.getDeviceSettings()
            }
            state.device_settings = payload
        },
        setRegistrationDetails: async (state, payload) => {
            if (payload) await Storage.setRegistrationDetails(payload);
            else payload = Storage.getRegistrationDetails()
            state.registrationDetails = payload
        },

        setDefaultStore: (state, data) => {
            state.defaultStore = data
            return Storage.setDefaultStore(data)
        },
    },
    actions: {
        ringBell: ({commit, getters}) => {
            let bell = getters.getNofiication
            if (!bell) {
                commit('setNotification')
                bell = getters.getNofiication;
            }
            bell.play()
        },
        syncData: async ({dispatch, commit}) => {
            return axios.all([
                dispatch('getAllUsers'),
                dispatch('getAllSecurities'),
            ]).then(() => {
                commit("setCurrentUser");
            });
        },
        appLogin: (context, payload) => {
            return axios.post(backOfficeTomcatApi + 'mobileUser/login', payload)
                .then(async ({data}) => {
                    await Storage.setAdminUser(payload)
                    await context.commit('setRegisteredStores', data)
                    // Attach the authenticated user to all subsequent Sentry events
                    // so they are attributable in the Sentry UI. PII fields (email)
                    // are still scrubbed by `redactPII` in `src/main.js` and by
                    // `dataCollection.userInfo: false`.
                    Sentry.setUser({
                        id: payload?.email || payload?.username || undefined,
                        username: payload?.email || payload?.username || undefined,
                    });
                }).catch((err) => errorHandler.tomcatError(err))
        },

        getCustomerDetails: async (context) => {
            let store = await Storage.getDefaultStore();
            if (!store) return;
            return axios.get(franchiseTomcatApi + `stores/getRegistrationDetails`, {
                params: {database: store.StoreDB}
            }).then(({data}) => context.commit(`setRegistrationDetails`, data))
                .catch((err) => errorHandler.tomcatError(err))
        },
        setDefaultStore: (context, data) => {
            context.commit('setDefaultStore', data)
            return context.dispatch('syncData')
        },
    },
})
